import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input, forwardRef } from '@angular/core';
import { UntypedFormControl, Validators, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { debounceTime, switchMap, catchError, distinctUntilChanged } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { AssignedTeamItem, Item } from 'app/models/item.inferface';
import { AuthService } from 'app/services/auth.service';
import { UserModel } from 'app/models/user.model';
import { UserItem } from 'app/models/user-item.model';
import { ClientByNameSuggestService } from 'app/services/suggest/client-by-name.suggest.service';
import { ConsultantByDescriptionSuggestService } from 'app/services/suggest/consultant-by-description.suggest.service';
import { SuggestType } from 'app/enums/suggest.enum';

@Component({
  selector: 'app-collaborator-suggest',
  templateUrl: './collaborator-suggest.component.html',
  styleUrls: ['./collaborator-suggest.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CollaboratorSuggestComponent),
      multi: true
    }
  ]
})
export class CollaboratorSuggestComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  suggestType = SuggestType;

  @Input() appearance;
  appearanceSet = '';
  @Input() placeholder = this.translate.instant('COLAB-SUGGEST.PLACEHOLDER-COLAB');
  placeholderSet = '';
  @Input() permission;
  @Input() required: boolean = false;
  @Input() endpoint: SuggestType = SuggestType.userSuggest;// this.suggestType.userSuggest;
  
  permissionSet = true;
  colabControlFormError = false;
  lockEvent = false;
  collaboratorAutoComplete$: Observable<Item[] | AssignedTeamItem[]> = null;
  autoCompleteControl: UntypedFormControl;

  // tslint:disable-next-line: variable-name
  private _unsubscribeAll: Subject<void>;
  private user: UserModel;
  private minCharSearch: number = 2;

  onChange = (x) => {};
  onTouched = (x) => {};

  constructor(
    private clientSuggestService: ClientByNameSuggestService,
    private consultantSuggestService: ConsultantByDescriptionSuggestService,
    private translate: TranslateService,
    // private progressService: FuseProgressBarService,
    private auth: AuthService,
    ) {
      this.user = this.auth.currentUser;
      this._unsubscribeAll = new Subject();
    }



  writeValue(obj: UserItem): void {
    this.autoCompleteControl.patchValue(obj);
  }
  registerOnChange(fn: () => {}): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.autoCompleteControl.disable() : this.autoCompleteControl.enable();
  }

  ngOnInit() {
    this.setPlaceholder();
    this.appearanceSet = this.appearance;

    this.translate.onLangChange
      .subscribe(
        () => {
          this.setPlaceholder();
        }
      );

    if (this.permission) {this.permissionSet = this.permission; }
    this.autoCompleteControl = new UntypedFormControl('', [this.autocompleteSelectionValidator]);

    this.autoCompleteControl.valueChanges.subscribe(value => {
      this.onChange(value);
    });
  }

  ngAfterViewInit() {
    this.collaboratorAutoComplete$ = this.autoCompleteControl.valueChanges.pipe(
      // delay emits
      debounceTime(300),
      distinctUntilChanged(),
      // use switch map so as to close previous subscribed events, before creating new once
      switchMap(value => {
        return value && value.length > this.minCharSearch ? this.search(value) : of(null);
      })
    );
  }

  setPlaceholder() {
    switch (this.placeholder) {
      case 'colab':
        this.placeholderSet = this.translate.instant('COLAB-SUGGEST.PLACEHOLDER-COLAB');
        break;
      case 'requester':
        this.placeholderSet = this.translate.instant('COLAB-SUGGEST.PLACEHOLDER-REQUESTER');
        break;
      case 'host':
        this.placeholderSet = this.translate.instant('COLAB-SUGGEST.PLACEHOLDER-HOST');
        break;
      case 'aprover':
        this.placeholderSet = this.translate.instant('COLAB-SUGGEST.PLACEHOLDER-APROVER');
        break;
      case 'client':
        this.placeholderSet = this.translate.instant('COLAB-SUGGEST.CLIENT');
      case 'consultant':
        this.placeholderSet = this.translate.instant('COLAB-SUGGEST.CONSULTANT');
        break;
    }
  }

  collaboratorLostFocus() {
  }

  search(value: string): Observable<Item[] | AssignedTeamItem[]> {
    return this.endpoint == this.suggestType.assignTeamSuggest ?
      this.consultantSuggestService.getTeamSuggestByDescription(value.toLowerCase())
        .pipe(catchError(_ => of(null))) :
      this.consultantSuggestService.getSuggestByDescription(value.toLowerCase())
        .pipe(catchError(_ => of(null)));
  }

  displayColab(colab?: Item | AssignedTeamItem): string | undefined {
    return colab ? colab.description : undefined;
  }

  private autocompleteSelectionValidator(control: UntypedFormControl) {
    const selection = control.value;
    if (typeof selection === 'string' && selection !== '') {
      return { incorrect: {} };
    }
    return null;
  }
}
